import React from 'react'
import { nextUpdateDisplayLabel, nextUpdateDisplayValue } from '../../utils'

export const StatusUpdateText: React.FC<{ status: number, time?: string | null, refreshInterval?: number | null }> = ( { status, time, refreshInterval } ) => {
	return (
		<>
			<b>{nextUpdateDisplayLabel( status )}</b>&nbsp;{nextUpdateDisplayValue( status, time, refreshInterval )}
		</>
	)
}
